// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3bhcA","textCnt":"style_textCnt__2AOFY","topHr1":"style_topHr1__I6tSY","topHr2":"style_topHr2__3GPIC","backbutton-withlines":"style_backbutton-withlines__2rvn3"};